import * as api from '../api.js';

export type ProviderNameFields = Pick<
  api.User.UserIdentification,
  'firstName' | 'lastName' | 'prefix' | 'suffix'
>;
const NON_DOCTOR_SUFFIX_SET = new Set<string>(Object.values(api.User.OtherSuffixMap));

export function formatProviderSpecialties(specialties: api.ProviderProfile.Profile['specialties']) {
  return specialties
    ?.map((specialty: api.Common.Specialty) => api.Common.SpecialtyMap[specialty])
    .sort()
    .join(', ');
}

export enum ProviderNameFormat {
  FullName = 'FullName',
  FullNameWithAffix = 'FullNameWithAffix',
}
export function getProviderNameFull(args: {
  provider: ProviderNameFields;
  format?: ProviderNameFormat;
}): string {
  const { provider, format = ProviderNameFormat.FullNameWithAffix } = args;
  const { firstName, lastName, prefix, suffix } = provider;
  const fullName = [firstName, lastName].filter((x) => !!x).join(' ');
  if (format === ProviderNameFormat.FullName || !fullName) {
    return fullName;
  }

  const providerSuffix = suffix ? `, ${suffix}` : '';
  if (!suffix || NON_DOCTOR_SUFFIX_SET.has(suffix.toUpperCase())) {
    const providerPrefix = prefix ? (prefix.endsWith('.') ? `${prefix} ` : `${prefix}. `) : '';
    return `${providerPrefix}${fullName}${providerSuffix}`;
  }
  return `${fullName}${providerSuffix}`;
}
